class CollectionFeatures extends HTMLElement {
    constructor() {
        super();
        this.options = this.querySelectorAll('.collections-bar input');
    }

    connectedCallback() {
        this.options.forEach(option => {
            option.addEventListener('click', () => {
                this.changeCollection(option);
            })
        });
        this.initDropdown();
      this.changeCollection(this.options[0]);
      this.toggleSlider();
      window.addEventListener('resize', () => {
        setTimeout(() => {
          this.toggleSlider();
        }, 300);
      });      
    }

    initDropdown() {
      // let dropdown = this.querySelector('.custom-dropdown details');
      // let items = dropdown.querySelectorAll('.dropdown-items__item');
      // items.forEach(item => {
      //   item.addEventListener('click', () => {
      //     dropdown.querySelector('summary').innerHTML = item.innerHTML + `
      //     <svg xmlns="http://www.w3.org/2000/svg" width="12" height="8" viewBox="0 0 12 8" fill="none">
      //     <path d="M1 1.5L6 6.5L11 1.5" stroke="#667085" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
      //   </svg>`;
      //     dropdown.removeAttribute('open');
      //     this.changeCollection(item);
      //   })
      // })
    }

  toggleSlider() {
    if ($(window).width() <= 991) {
      let itemToshow = parseFloat($(`.collections-items__content.showtab > .collections-items__content-cards`).data('items')) || 1.4;

      if(!$(`.collections-items__content.showtab > .collections-items__content-cards`).hasClass('slick-initialized')) {
        $(`.collections-items__content.showtab>.collections-items__content-cards`).slick({
          slidesToShow: 4,
          slidesToScroll: 1,
          arrows: true,
          infinite: false,
          responsive: [
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: itemToshow,
                slidesToScroll: 1
              }
            }
          ]
        });
      }
    } else {
      if ($(`.collections-items__content.showtab > .collections-items__content-cards`).hasClass('slick-initialized')) {
        $(`.collections-items__content.showtab > .collections-items__content-cards`).slick('unslick');
      }
    }
  }

    changeCollection(el) {
      if (!el.classList.contains('active')) {
        window.dispatchEvent(new Event('resize'));
        el.classList.add('active');
      };
        let collections = this.querySelectorAll('.collections-items__wrapper .collections-items__content');
        collections.forEach(collection => {
            if(collection.getAttribute('index') == el.getAttribute('value')) {
                collection.classList.remove('hidden');
              collection.classList.add('showtab');
              // let cards = collection.querySelectorAll('.showtab .collections-items__content-cards .product__card');
              // cards.forEach(card => {
              //   card.classList.add('opacity-0');
              // });
              if ($(window).width() <= 991) {
                      if(collection.querySelector('.collections-items__content-cards').classList.contains('slick-initialized')) {
                        $(`.collections-items__content-cards[index=${el.getAttribute('value')}]`).slick('unslick');
                      }
                        let inCardCount = collection.querySelectorAll(".collections-items__content-cards .items-content__card")
                        let itemToshow = parseFloat($(".collections-items__content-cards").data('items')) || 1.4;                        

                        $(`.collections-items__content-cards[index=${el.getAttribute('value')}]`).slick({
                          slidesToShow: 4,
                          slidesToScroll: 1,
                          arrows: true,
                          infinite: false,
                          responsive: [
                            {
                              breakpoint: 992,
                              settings: {
                                slidesToShow: 2,
                                slidesToScroll: 1
                              }
                            },
                            {
                              breakpoint: 768,
                              settings: {
                                slidesToShow: itemToshow,
                                slidesToScroll: 1
                              }
                            }
                          ]
                        });
                    }
              //}
              window.dispatchEvent(new Event('resize'));
            }else {
              collection.classList.add('hidden')
              collection.classList.remove('showtab')
            }
        })
    }
}

customElements.define("collection-features", CollectionFeatures);